import { MenuItemType } from "../../../components/generic/SideNavComponents/menuItem";
import { ApiSchemaMenuBuilder } from "../../../models/api/apiSchemaLogin";
import { MenuData } from "../../../components/generic/SideNavComponents/menuItemsData";
import { StorageAuth } from "../../localStorage/StorageAuth";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SliceUserRole = {
  menuItems: MenuItemType[];
};

function GetMenuItems(items?: ApiSchemaMenuBuilder): MenuItemType[] {
  if (items) {
    return MenuData[items.roles] ?? [];
  }
  return [];
}

function InitSliceMenuByRole(): SliceUserRole {
  const menuItemData = StorageAuth.Menu;
  const menuItems = GetMenuItems(menuItemData);
  return {
    menuItems,
  };
}

const sliceMenuByRole = createSlice({
  name: "sliceMenuByRole",
  initialState: InitSliceMenuByRole(),
  reducers: {
    SetMenuItems: (
      state,
      action: PayloadAction<ApiSchemaMenuBuilder>
    ): void => {
      StorageAuth.Menu = action.payload;
      state.menuItems = GetMenuItems(action.payload);
    },
  },
});

export const { SetMenuItems: setMenuItems } = sliceMenuByRole.actions;
export const ReducerMenuByRole = sliceMenuByRole.reducer;
export const ActionMenuByRole = sliceMenuByRole.actions;
